import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    'b-spinner': BSpinner
  },
  props: {
    status: {
      type: Boolean,
      default: false
    },
    mensagem: {
      type: String,
      default: ''
    },
    cssClass: {
      type: String
    }
  }
}
